import type { HelpFile } from '../../types/help'
import { CreateInboundConnectorDialogTestIds } from '../../../testids/CreateInboundConnectorDialogTestIds'

export const createInboundConnectorDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [CreateInboundConnectorDialogTestIds.inboundConnectorTypeSelect]: 'Type of inbound connector — SCIM, LDAP, or script.',
    [CreateInboundConnectorDialogTestIds.inboundCronError]: null,
    [CreateInboundConnectorDialogTestIds.inboundCronInput]: 'Cron expression that controls how often this connector runs.',
    [CreateInboundConnectorDialogTestIds.inboundCronPreview]: 'Human-readable preview of when the cron expression next fires.',
    [CreateInboundConnectorDialogTestIds.inboundDisplayNameError]: null,
    [CreateInboundConnectorDialogTestIds.inboundDisplayNameInput]: null,
    [CreateInboundConnectorDialogTestIds.inboundEnabledSwitch]: 'Disabled connectors are not scheduled and will not run.',
    [CreateInboundConnectorDialogTestIds.inboundTargetSystemCombobox]: 'Target system this inbound connector pulls data from.',
    [CreateInboundConnectorDialogTestIds.inboundTargetSystemError]: null,
  },
}
